/**
 * 学习乐园 · 连连看题材包：典故配人物（lianliankan/pack-dianxing.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：成语典故连主人公（「卧薪尝胆」连「勾践」）。note 存一句
 * 典故要义——配上的那一瞬把故事讲一遍，成语与人物、与故事三者挂钩
 * （消除与配错反馈双向展示）。
 * 口径自检：20 条典故的主人公互不重复——同一人物出现两次会造成
 * 两张同名牌分属不同对，配错反馈就没法指对搭档（rel 型按 pair 报
 * mate，同 face 两张牌玩家无法区分）。
 * 20 对备 18 对/局，每局组合不同。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.dianxing = {
    id: 'dianxing',
    name: '典故配人物',
    hint: '卧薪尝胆连勾践，配错讲典故',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '卧薪尝胆', r: '勾践', note: '越王睡柴尝苦胆，立志复国' },
      { l: '负荆请罪', r: '廉颇', note: '背荆条向蔺相如认错' },
      { l: '完璧归赵', r: '蔺相如', note: '和氏璧完好送回赵国' },
      { l: '纸上谈兵', r: '赵括', note: '空谈兵法，长平大败' },
      { l: '三顾茅庐', r: '刘备', note: '三次拜访请诸葛亮出山' },
      { l: '破釜沉舟', r: '项羽', note: '砸锅沉船，决一死战' },
      { l: '望梅止渴', r: '曹操', note: '说前方有梅林，士兵生津' },
      { l: '闻鸡起舞', r: '祖逖', note: '鸡叫就起，舞剑练武' },
      { l: '凿壁偷光', r: '匡衡', note: '凿墙借光，夜夜苦读' },
      { l: '悬梁刺股', r: '孙敬', note: '头发绑在房梁上防瞌睡' },
      { l: '铁杵磨针', r: '李白', note: '受老妪磨针启发，发奋读书' },
      { l: '胸有成竹', r: '文同', note: '画竹前心里已有竹的样子' },
      { l: '指鹿为马', r: '赵高', note: '故意颠倒黑白试探人心' },
      { l: '草木皆兵', r: '苻坚', note: '疑心草木都是敌兵' },
      { l: '精忠报国', r: '岳飞', note: '岳母在他背上刺下四字' },
      { l: '程门立雪', r: '杨时', note: '雪中等老师醒来不打扰' },
      { l: '入木三分', r: '王羲之', note: '笔力透进木板三分深' },
      { l: '乐不思蜀', r: '刘禅', note: '在魏国享乐，不想故国' },
      { l: '才高八斗', r: '曹植', note: '谢灵运赞他天下才学占八斗' },
      { l: '画龙点睛', r: '张僧繇', note: '点上眼睛，龙破壁飞去' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
